
const BEACON_URL_HE = 'https://beacon.peakd.com/api/he/nodes';

// testnet: 'https://enginetestnet.rishipanthee.com/contracts'
const FALLBACK_NODE = 'https://engine.hive.pizza';;

const REQUIRED_FEATURES = ['is_full'];

const VERBOSE = true;


const withPath = (url) => `${url}/contracts`;


export const findHealthyNode = async () => {
  const response = await fetch(BEACON_URL_HE);
  if (!response.ok) {
    console.error(`Failed to fetch node data: ${response.status} ${response.statusText}`);
    return withPath(FALLBACK_NODE);
  }
  const data = await response.json();
  VERBOSE && console.log('[he-nfts] Beacon health response:', data);
  const validNodes = data.filter((node = {}) => {
    if (node.fail !== 0) return false;
    if (!Array.isArray(node.features)) return false;
    return REQUIRED_FEATURES.every((feature) => node.features.includes(feature));
  });

  // We pick the first valid node whose endpoint responds successfully, else try the next
  const nodesToCheck = [{ endpoint: FALLBACK_NODE }, ...validNodes];
  for (const node of nodesToCheck) {
    const url = node?.endpoint;
    VERBOSE && console.log('[he-nfts] Double checking health status for', url);
    try {
      const testRes = await fetch(url);
      if (testRes.ok) {
        // We found a healthy node
        return withPath(url);
      }
    } catch (err) {
      console.warn(`Request failed for ${url}, trying next...`);
    }
  }

  console.error('No healthy node found among the available options from', BEACON_URL_HE);
  return withPath(FALLBACK_NODE);
};
